"use client";
import { ArrowRight } from "@/components/icons/ArrowRight";
import { useStore } from "@nanostores/react";
import clsx from "clsx";
import type { SearchSpeaker } from "front-search-schema/meili";
import { atom } from "nanostores";
import { ChevronDownIcon } from "ui/iconsN";
import type { SpeakersSearch } from "../page";
import { Speaker } from "./Speaker";

const showAllAtom = atom(false);

type Props = {
  search: SpeakersSearch;
  speakers: Array<SearchSpeaker>;
};
export const Container = ({ search, speakers }: Props) => {
  const showAll = useStore(showAllAtom);

  return (
    <div className="relative overflow-hidden">
      <div className="flex flex-wrap justify-center gap-6 mt-6">
        {speakers
          .sort((a, b) => b.nextDepartureCount - a.nextDepartureCount)
          .slice(0, showAll && !search.n ? speakers.length : 12)
          .map((speaker) => (
            <Speaker key={speaker.id} speaker={speaker} />
          ))}
      </div>
      {showAll && !search.n && (
        <div className="hidden lg:block absolute top-0 bottom-0 -right-24 w-10">
          <div
            className="bg-pr-1 rounded-full sticky top-3/4 w-10 h-10 cursor-pointer grid place-items-center"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <ArrowRight className="fill-white text-white -rotate-90 w-5" />
          </div>
        </div>
      )}
      {!showAll && !search.n && (
        <div className="absolute h-48 -bottom-6 -right-6 -left-6 bg-linear-to-t from-white via-white" />
      )}
      {!search.n && (
        <div
          className={clsx(
            "absolute left-1/2 -translate-x-1/2 p-1 flex items-center gap-1.5 text-sm/4 font-medium cursor-pointer text-tx-2 stroke-tx-2",
            {
              "-bottom-12": showAll,
              "bottom-8": !showAll,
            },
          )}
          onClick={() => showAllAtom.set(!showAll)}
        >
          <ChevronDownIcon className={clsx({ "rotate-180": showAll })} />
          {showAll ? "Voir moins" : "Voir tous les conférenciers"}
          <ChevronDownIcon className={clsx({ "rotate-180": showAll })} />
        </div>
      )}
    </div>
  );
};
